export default __webpack_public_path__ + "static/media/apple.3971bdf0.ogg";